module.exports = __webpack_public_path__ + "static/media/search-icon.a5921a3d.svg";